import Popin from './popin';

export default () => {
    // console.log('secretarySingle');

    new Popin({
        id: 'popin-secretary-single',
        beforeOpen() {
        },
        afterOpen() {
        },
        beforeClose() {
        },
        afterClose() {
        },
    });
};
